import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-8xl font-bold text-[#5EABEB] mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-slate-900 mb-2">
          Pagina niet gevonden
        </h2>
        <p className="text-slate-600 mb-8">
          De pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-lg bg-[#5EABEB] text-white font-semibold hover:bg-[#4A9FE6] transition-colors"
        >
          <Home className="w-4 h-4" />
          Terug naar home
        </Link>
      </div>
    </div>
  );
}
